import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { useGetGoalsMissing } from '../../dataHooks/timelineAndRemindersSectionHooks';
import { ValidationTable } from './ValidationTable';

const GoalsMissingValidation = () => {
  const { data: rowData, isLoading } = useGetGoalsMissing();
  const { keyResultsName } = useOrganisationSettings();

  return (
    <ValidationTable
      rowData={rowData}
      isLoading={isLoading}
      title={`${modifyString(keyResultsName, StringModifier.PLURAL_TITLE_CASE)} Missing`}
      // subTitle={`These employees will not receive any questions in goals section as they do not have any ${modifyString(
      //   keyResultsName,
      //   StringModifier.PLURAL_TITLE_CASE
      // )}`}
      subTitle={`Employees without ${modifyString(
        keyResultsName,
        StringModifier.PLURAL_TITLE_CASE
      )} will not see any questions in the ${modifyString(
        keyResultsName,
        StringModifier.TITLE_CASE
      )} section. You can download their list and either ask them to create ${modifyString(
        keyResultsName,
        StringModifier.PLURAL_TITLE_CASE
      )} or upload the ${modifyString(keyResultsName, StringModifier.PLURAL_TITLE_CASE)} for them.`}
    />
  );
};

export { GoalsMissingValidation };
